/**
 * The "Invite Companions"/"Invited Companions" checklist shared by the
 * Create and Edit trip modals: a bordered list of the user's community
 * members, each with an avatar, name and checkbox. Mirrors the Android
 * app's own companion picker in CreateTripScreen/EditTripScreen.
 *
 * @param {string} label - "Invite Companions" (create) or "Invited Companions" (edit)
 * @param {{memberId: string, name: string, initials: string, profilePictureUrl: string|null}[]} companions
 * @param {Set<string>} selectedIds
 * @param {(memberId: string) => void} onToggle
 * @param {boolean} isLoading
 */
export default function CheckerCompanionPicker({
    label,
    companions,
    selectedIds,
    onToggle,
    isLoading,
}) {
    return (
        <div className="checker-companion-picker">
            <div className="checker-companion-picker-header">
                <span className="checker-preset-label">{label}</span>
                {selectedIds.size > 0 && (
                    <span className="checker-companion-picker-count">
                        {selectedIds.size} selected
                    </span>
                )}
            </div>

            {isLoading ? (
                <div className="checker-companion-picker-loading">
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-label="Loading community members"
                    ></span>
                </div>
            ) : companions.length === 0 ? (
                <p className="checker-companion-picker-empty">
                    No community members to invite yet -- add people to a
                    community first.
                </p>
            ) : (
                <div className="checker-companion-picker-list">
                    {companions.map((companion) => {
                        const isSelected = selectedIds.has(companion.memberId)
                        return (
                            <label
                                className="checker-companion-picker-row"
                                key={companion.memberId}
                            >
                                <span className="checker-companion-avatar">
                                    {companion.profilePictureUrl ? (
                                        <img
                                            src={companion.profilePictureUrl}
                                            alt=""
                                        />
                                    ) : (
                                        <span>{companion.initials}</span>
                                    )}
                                </span>
                                <span className="checker-companion-picker-name">
                                    {companion.name}
                                </span>
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={isSelected}
                                    onChange={() => onToggle(companion.memberId)}
                                />
                            </label>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
